module.exports = __webpack_public_path__ + "static/media/termopary1ru.86ca0c5a.pdf";